import React, { useCallback, useEffect } from 'react';
import { MainContainer, MainContent, HeaderChat, Profile } from './styles';
import Conversations from '../conversations';
import { useConversation } from '../../hooks/conversation';
import { useMain } from '../../hooks/main';
import Groups from '../groups';
import { getServerSentEventPath } from '../../storage';
import { REACT_APP_ENABLE_SERVERSENTEVENT } from '../../config';
import { useChatMessages } from '../../hooks/chat';
import {
  startSSEConnection,
  closeSSEConnection,
} from '../../services/sseManager';

const Main = () => {
  const { GetUserConversations, setHasCall, setSSEConnectionActive } =
    useConversation();
  const { setHasUpdate } = useChatMessages();
  const { page, setPage } = useMain();
  const handleChange = useCallback(
    (event, value) => {
      setPage(value);
    },
    [setPage]
  );

  // if identification id not exist => return to login page
  // Check BEFORE rendering anything
  const id = localStorage.getItem('@Squre:IdentificationId');
  if (!id) {
    window.location.href = '/'; // immediate redirect
    return null;
  }

  // useEffect(() => {
  //   const receiverId = localStorage.getItem('@Squre:IdentificationId');

  //   if (receiverId) {
  //     startSSEConnection({
  //       receiverId,
  //       onOpen: () => setSSEConnectionActive(true),
  //       onMessage: async (data) => {
  //         try {
  //           console.log('Received SSE data:', data);

  //           await GetUserConversations();

  //           if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
  //             setHasUpdate((prev) => (prev === 0 ? 1 : 0));
  //           }

  //           if (data === 'Call All' || data === 'Call to only this User') {
  //             setHasCall((prev) => (prev === 0 ? 1 : 0));
  //           }
  //         } catch (err) {
  //           console.error('SSE message handler failed:', err);
  //         }
  //       },
  //       onError: () => setSSEConnectionActive(false),
  //     });
  //   }
  // }, []);

  useEffect(() => {
    const receiverId = localStorage.getItem('@Squre:IdentificationId');

    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true' && receiverId) {
      startSSEConnection({
        receiverId,
        onOpen: () => setSSEConnectionActive(true),
        onMessage: async (data) => {
          try {
            console.log('Received SSE data:', data);

            await GetUserConversations();

            setHasUpdate((prev) => (prev === 0 ? 1 : 0));

            if (data === 'Call All' || data === 'Call to only this User') {
              setHasCall((prev) => (prev === 0 ? 1 : 0));
            }
          } catch (err) {
            console.error('SSE message handler failed:', err);
          }
        },
        onError: () => setSSEConnectionActive(false),
      });
    }
  }, []);

  return (
    <MainContainer>
      <MainContent>
        <Conversations />
      </MainContent>
    </MainContainer>
  );
};

export default Main;
